import React from 'react';
import P from 'prop-types';

const ArrowDown = ({ size, fill, className }) => {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24">
      <path fill={fill} d="M12.414 16.414a.997.997 0 0 1-.707-.293L7 11.414 8.414 10l4 4 4-4 1.414 1.414-4.707 4.707a.997.997 0 0 1-.707.293z" />
    </svg>
  );
};

ArrowDown.propTypes = {
  size: P.number,
  fill: P.string,
  className: P.string,
};

ArrowDown.defaultProps = {
  fill: '#E86C60',
};

export default ArrowDown;
